// TODO(PROMO): Remove Dummy Data
export const DEMO_PRODUCTS = [
  {
    id: '4f71a943-6c09-4a88-b311-d0fd2d54fcea',
    title: 'FERRERO ROCHER T24 DIAMANTE 300 GR',
    desc: 'FERRERO ROCHER T24 DIAMANTE 300 GR',
    type: 'ZTRD',
    pack_unit: '300 GR',
    information: 'Cokelat dengan Kacang Hazel',
    composition:
      'KOMPOSISI: COKELAT SUSU 30.3% (GULA, LEMAK KAKAO, KAKAO MASSA, SUSU SKIM BUBUK, LEMAK SUSU ANHIDRAT,PENGEMULSI: LESITIN (KEDELAI), PERISA: SINTETIK VANILA), KACANG HAZEL 28.8%, GULA, MINYAK NABATI, TEPUNG TERIGU,BUBUK WHEY, KAKAO BUBUK, PENGEMULSI: LESITIN (KEDELAI), PENGEMBANG (NATRIUM BIKARBONAT), GARAM, PERISA:SINTETIK VANILA.',
    superiority:
      '- Menggunakan resep asli dari Ferrero yang dirpduksi dari luar negeri (Alba, Italia)- Menggunakan bahan-bahan yang berkualitas dan halal- Camilan lezat dan elegan untuk momen dan perayaan spesial dan untuk hadiah',
    item_code: 20000458,
    brand_name: 'ROCHER',
    brand_desc: 'ROCHER',
    division: 'trading',
    product_storage: 'dry_ac',
    barcode: '8000500009673',
    measurement_unit: 'PAC',
    measurement_unit_desc: 'Pack',
    sales_unit: 'PAC',
    sales_unit_desc: 'Pack',
    dimension: '23,200 X 23,200 X 18,200',
    dimension_unit: 'CM',
    gross_weight: 1.224,
    net_weight: 0.3,
    weight_unit: 'KG',
    gross_weight_desc: '1.224 KG',
    net_weight_desc: '0.3 KG',
    volume: 9795.968,
    volume_unit: 'CCM',
    minimum_order_quantity: 1000,
    order_quantity_multiple: 1000,
    stock: 8000,
    stock_status: 'AVAILABLE',
    category_name: 'CONFECTIONERY',
    wishlist_id: null,
    product_images: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/20000458_1.jpg',
    ],
    product_image_thumbnails: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/thumbnails/20000458_1_thumbnail_150.webp',
    ],
    product_images_medium: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/medium/20000458_1_medium_400.webp',
    ],
    product_images_large: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/large/20000458_1_large_700.webp',
    ],
    prices: [
      {
        price: 163614,
        min_order_quantity: 1,
      },
    ],
    stock_magnifier: 1000,
    sub_category_name: 'CHOCOLATE',
    sub_third_category_name: 'CHOCOLATE',
    promo_types: ['free-item', 'discount'] as const,
    discount_amount: 0.2,
  },
  {
    id: 'eaf5a6f2-7fa4-48ee-b088-59fc524f2af6',
    title: 'BEEF BULGOGI FRIED NOODLE 105 GR',
    desc: 'NONG SHIM BEEF BULGOGI FRIED NOODLE',
    type: 'ZTRD',
    pack_unit: '30X105 GR',
    information:
      'Merupakan ramyun kering dengan rasa saus Bulgogi dan daging sapi yang memungkinkan konsumen untuk mencicipi rasa authentic Bulgogi dari Korea Selatan secara instant dan nyaman.\r\nanjakan di setiap gigitannya.\r\n',
    composition:
      'Mie: Tepung gandum, pati kentang, minyak nabati, pengental pati asetat, garam, pengatur keasaman kalium karbonat, pewarna alami riboflavin, esktrak teh hijau. Bumbu siap pakai: Gula, hidrolisat protein nabati, penguat rasa (mononatrium L-glutamate & Dinatrium 5-ribonukleotida), rempah, garam, glukosa, maltodektrin, pewarna alami karamel I, perisa sintetik, minyak nabati, pengatur keasaman (kalium karbonat, Asam sitrat), antikempal silikon dioksida halus, estrak ragi, antioksidan tokoferol campuran pekat. Sayuran kering: Protein kedelai tertekstur, daun bawang kering, cabai kering\r\n',
    superiority:
      '1) Halal MUI ; 2) Citarasa Bulgogi tradisional Korea; 3) Stir Fry Ramyun\r\n',
    item_code: 20002900,
    brand_name: 'NFH',
    brand_desc: 'NFH',
    division: 'trading',
    product_storage: 'dry',
    barcode: '6920238091677',
    measurement_unit: 'PC',
    measurement_unit_desc: 'Piece',
    sales_unit: 'PC',
    sales_unit_desc: 'Piece',
    dimension: '15,800 X 3,000 X 20,000',
    dimension_unit: 'CM',
    gross_weight: 0.11,
    net_weight: 0.105,
    weight_unit: 'KG',
    gross_weight_desc: '0.11 KG',
    net_weight_desc: '0.105 KG',
    volume: 948,
    volume_unit: 'CCM',
    minimum_order_quantity: 1000,
    order_quantity_multiple: 1000,
    stock: 191494000,
    stock_status: 'AVAILABLE',
    category_name: 'PASTA AND NOODLES',
    wishlist_id: null,
    product_images: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/20002900_1.jpg',
    ],
    product_image_thumbnails: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/thumbnails/20002900_1_thumbnail_150.webp',
    ],
    product_images_medium: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/medium/20002900_1_medium_400.webp',
    ],
    product_images_large: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/large/20002900_1_large_700.webp',
    ],
    prices: [
      {
        price: 12644,
        min_order_quantity: 1,
      },
    ],
    stock_magnifier: 1000,
    sub_category_name: 'NOODLES',
    sub_third_category_name: 'INSTANT',
    promo_types: ['free-item', 'cashback'] as const,
    cashback_amount: 5_000,
  },
  {
    id: '9371919a-ccf7-4257-9390-5cd970cf6ff2',
    title: 'BEEF BRATWURST 1 KG',
    desc: 'BEEF BRATWURST 1 KG',
    type: 'ZTRD',
    pack_unit: '1 KG',
    information:
      'Riverland Bratwurst memiliki cita rasa rempah-rempah yang cukup pekat dan nikmat',
    composition:
      'Daging sapi, daging ayam, air, tepung tapioka, isolate soy protein, garam, gula, flavor enhancer monosodium glutamat, stabilizer fosfat, kalium sorbat, sodium nitrit, antioksidan asam askorbat',
    superiority:
      'Bahan yang berkualitas, Juicy, praktis, resep asli Jepang, tidak menggunakan MDM',
    item_code: 20002450,
    brand_name: 'RIVERLAND',
    brand_desc: 'RIVERLAND',
    division: 'trading',
    product_storage: 'frozen',
    barcode: ' ',
    measurement_unit: 'PAC',
    measurement_unit_desc: 'Pack',
    sales_unit: 'PAC',
    sales_unit_desc: 'Pack',
    dimension: '0,000 X 0,000 X 0,000',
    dimension_unit: ' ',
    gross_weight: 1.102,
    net_weight: 1,
    weight_unit: 'KG',
    gross_weight_desc: '1.102 KG',
    net_weight_desc: '1. KG',
    volume: 2314.042,
    volume_unit: 'CCM',
    minimum_order_quantity: 1000,
    order_quantity_multiple: 1000,
    stock: 0,
    stock_status: 'OUT_OF_STOCK',
    category_name: 'MEAT AND SEAFOOD',
    wishlist_id: null,
    product_images: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/20002450_1.jpg',
    ],
    product_image_thumbnails: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/thumbnails/20002450_1_thumbnail_150.webp',
    ],
    product_images_medium: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/medium/20002450_1_medium_400.webp',
    ],
    product_images_large: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/large/20002450_1_large_700.webp',
    ],
    prices: [
      {
        price: 0,
        min_order_quantity: 1,
      },
    ],
    stock_magnifier: 1000,
    sub_category_name: 'PROCESSED BEEF',
    sub_third_category_name: 'SAUSAGE',
  },
  {
    id: '59ada7bd-632b-4562-abd9-11ae264a67d9',
    title: 'BANANA MUFFIN 85 GR',
    desc: 'BANANA MUFFIN 85 GR',
    type: 'ZFGD',
    pack_unit: '24X85GR',
    information: 'Muffin dengan balutan rasa pisang disetiap gigitannya',
    composition:
      'protein flour 11-12.5 S, refined sugar, whole egg frozen, salt, whole milk powder, malt powder, sodium bicarbonate double acting, palm oil, fruit puree banana ',
    superiority:
      '1) Tekstur lembut  2) Mudah di siapkan/reheat3) Frozen Food, bisa disimpan sampai 4 bulan4) Menghemat waktu preparasi di kitchen sampai 2 jam',
    item_code: 10000388,
    brand_name: 'BONPATIS',
    brand_desc: 'BONPATIS',
    division: 'trading',
    product_storage: 'frozen',
    barcode: ' ',
    measurement_unit: 'CAR',
    measurement_unit_desc: 'Carton',
    sales_unit: 'CAR',
    sales_unit_desc: 'Carton',
    dimension: '30,800 X 45,500 X 9,200',
    dimension_unit: 'CM',
    gross_weight: 2.51,
    net_weight: 2.04,
    weight_unit: 'KG',
    gross_weight_desc: '2.51 KG',
    net_weight_desc: '2.04 KG',
    volume: 12892.88,
    volume_unit: 'CCM',
    minimum_order_quantity: 1000,
    order_quantity_multiple: 1000,
    stock: 103000,
    stock_status: 'LIMITED_STOCK',
    category_name: 'BAKERY AND PASTRY',
    wishlist_id: 'fde34afc-044d-4730-8cdb-9caf616a71a3',
    product_images: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/10000388_1.jpg',
    ],
    product_image_thumbnails: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/thumbnails/10000388_1_thumbnail_150.webp',
    ],
    product_images_medium: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/medium/10000388_1_medium_400.webp',
    ],
    product_images_large: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/large/10000388_1_large_700.webp',
    ],
    prices: [
      {
        price: 250749,
        min_order_quantity: 1,
      },
    ],
    stock_magnifier: 1000,
    sub_category_name: 'WESTERN PASTRY',
    sub_third_category_name: 'OTHERS',
    promo_types: ['cashback'] as const,
    cashback_amount: 30_000,
  },
  {
    id: '85b0096e-a4f3-4211-851b-93d5aaf9bb01',
    title: 'BANANA BREAD 450 GR',
    desc: 'BANANA BREAD 450 GR',
    type: 'ZTRD',
    pack_unit: '450 GR',
    information:
      'Product Information:YesYouCan Banana Bread Mix sangat mudah diolah menjadi Banana Bread dengan citarasa yang enak, lembut dan sangat kental citarasa pisangnya. Produk ini semakin menarik dan baik untuk kesehatan karena Gluten Free, Egg Free, Nut Free, GMO Free, Low FODMAP, No Artificial Flavours and Colours, serta sangat cocok untuk para vegan.',
    composition:
      'Product Ingredients:Gula, Tepung Jagung, Pati Jagung, Pati Tapioka, Minyak Goreng Kelapa Sawit, Pati Kentang, Serpihan Pisang (4%), Maltodekstrin, Pengembang, Pengental Nabati, Kayu Manis, Perisa Alami, Garam, Biji Pala.',
    superiority:
      'Product Advantage:1) Gluten Free2) Egg Free3) Nut Free4) GMO Free5) Tanpa Pewarna dan Perisa Buatan',
    item_code: 20000695,
    brand_name: 'YYC',
    brand_desc: 'YES YOU CAN',
    division: 'fnb',
    product_storage: 'dry_ac',
    barcode: '9328987005421',
    measurement_unit: 'PAC',
    measurement_unit_desc: 'Pack',
    sales_unit: 'PAC',
    sales_unit_desc: 'Pack',
    dimension: '13,000 X 5,000 X 20,000',
    dimension_unit: 'CM',
    gross_weight: 0.45,
    net_weight: 0.45,
    weight_unit: 'KG',
    gross_weight_desc: '0.45 KG',
    net_weight_desc: '0.45 KG',
    volume: 1300,
    volume_unit: 'CCM',
    minimum_order_quantity: 1000,
    order_quantity_multiple: 1000,
    stock: 198000,
    stock_status: 'LIMITED_STOCK',
    category_name: 'BAKING NEEDS',
    wishlist_id: null,
    product_images: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/20000695_1.jpg',
    ],
    product_image_thumbnails: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/thumbnails/20000695_1_thumbnail_150.webp',
    ],
    product_images_medium: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/medium/20000695_1_medium_400.webp',
    ],
    product_images_large: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/large/20000695_1_large_700.webp',
    ],
    prices: [
      {
        price: 70399,
        min_order_quantity: 1,
      },
    ],
    stock_magnifier: 1000,
    sub_category_name: 'FLOUR AND PREMIX',
    sub_third_category_name: 'FLOUR AND PREMIX',
    promo_types: ['free-item'] as const,
  },
  {
    id: '0164096a-821e-4b98-90ed-b6fd7a72e227',
    title: 'BALSAMIC VINEGAR 500 ML',
    desc: 'BALSAMIC VINEGAR 500ML',
    type: 'ZTRD',
    pack_unit: '500 ML',
    information:
      'Filippo Berio Balsamic Vinegar terbuat dari anggur pilihan. Dengan rasa yang unik cocok untuk memanggang ikan, daging, dan juga bahan untuk salad dan saus',
    composition: 'cuka anggur, konsentrat anggur',
    superiority: 'dari anggur pilihanbaik untuk memanggangcocok untuk dressing',
    item_code: 20000197,
    brand_name: 'F_BERIO',
    brand_desc: 'FILIPPO BERIO',
    division: 'trading',
    product_storage: 'dry',
    barcode: '8002210122536',
    measurement_unit: 'BT',
    measurement_unit_desc: 'Bottle',
    sales_unit: 'BT',
    sales_unit_desc: 'Bottle',
    dimension: '6,500 X 6,500 X 27,500',
    dimension_unit: 'CM',
    gross_weight: 0.983,
    net_weight: 0.485,
    weight_unit: 'KG',
    gross_weight_desc: '0.983 KG',
    net_weight_desc: '0.485 KG',
    volume: 1161.875,
    volume_unit: 'CCM',
    minimum_order_quantity: 1000,
    order_quantity_multiple: 1000,
    stock: 1990000,
    stock_status: 'AVAILABLE',
    category_name: 'SEASONING, SAUCE, & DRESSING',
    wishlist_id: null,
    product_images: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/20000197_1.jpg',
    ],
    product_image_thumbnails: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/thumbnails/20000197_1_thumbnail_150.webp',
    ],
    product_images_medium: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/medium/20000197_1_medium_400.webp',
    ],
    product_images_large: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/large/20000197_1_large_700.webp',
    ],
    prices: [
      {
        price: 80122,
        min_order_quantity: 1,
      },
    ],
    stock_magnifier: 1000,
    sub_category_name: 'VINEGARS',
    sub_third_category_name: 'VINEGAR',
    promo_types: ['discount'] as const,
    discount_amount: 0.4,
  },
  {
    id: 'b79aaad4-3543-47b1-a25c-8ae8f740a6d3',
    title: 'BALSAMIC VINEGAR 250 ML',
    desc: 'BALSAMIC VINEGAR 250ML',
    type: 'ZTRD',
    pack_unit: '250 ML',
    information:
      'Filippo Berio Balsamic Vinegar terbuat dari anggur pilihan. Dengan rasa yang unik cocok untuk memanggang ikan, daging, dan juga bahan untuk salad dan saus',
    composition: 'cuka anggur, konsentrat anggur',
    superiority: 'dari anggur pilihanbaik untuk memanggangcocok untuk dressing',
    item_code: 20000196,
    brand_name: 'F_BERIO',
    brand_desc: 'FILIPPO BERIO',
    division: 'trading',
    product_storage: 'dry',
    barcode: '8002210122499',
    measurement_unit: 'BT',
    measurement_unit_desc: 'Bottle',
    sales_unit: 'BT',
    sales_unit_desc: 'Bottle',
    dimension: '5,000 X 5,000 X 21,500',
    dimension_unit: 'CM',
    gross_weight: 0.942,
    net_weight: 0.243,
    weight_unit: 'KG',
    gross_weight_desc: '0.942 KG',
    net_weight_desc: '0.243 KG',
    volume: 537.5,
    volume_unit: 'CCM',
    minimum_order_quantity: 1000,
    order_quantity_multiple: 1000,
    stock: 3717000,
    stock_status: 'AVAILABLE',
    category_name: 'SEASONING, SAUCE, & DRESSING',
    wishlist_id: null,
    product_images: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/20000196_1.jpg',
    ],
    product_image_thumbnails: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/thumbnails/20000196_1_thumbnail_150.webp',
    ],
    product_images_medium: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/medium/20000196_1_medium_400.webp',
    ],
    product_images_large: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/large/20000196_1_large_700.webp',
    ],
    prices: [
      {
        price: 46777,
        min_order_quantity: 1,
      },
    ],
    stock_magnifier: 1000,
    sub_category_name: 'VINEGARS',
    sub_third_category_name: 'VINEGAR',
  },
  {
    id: '3f55fa1a-05c0-4dd1-9f64-7fe441808609',
    title: 'BAG STRAWBERRY ORANGE 90 GR',
    desc: 'BAG STRAWBERRY ORANGE 90 GR',
    type: 'ZTRD',
    pack_unit: '30X90 GR',
    information:
      'Permen lunak dengan tekstur lembut. Perpaduan rasa buah-buahan dan yoghurt yang segar, membuat hari-hari menjadi lebih berwarna',
    composition:
      'Gula, sirup glukosa, minyak nabati, pengental (gelatin sapi), pengatur keasaman asam sitrat, perisa artifisial (yoghurt, strawberry, jeruk), bubuk strawberry dan jeruk (0.06%), gom arab, pewarna artifisial kuning FCF CI 15985, ponceau 4R CI no. 16255',
    superiority:
      '- sudah ada di Indonesia lebih dari 40 tahun\r\n  - bahan berkualitas tinggi\r\n  - perpaduan rasa buah dan yogurt yang segar',
    item_code: 20000559,
    brand_name: 'SUGUS',
    brand_desc: 'SUGUS',
    division: 'trading',
    product_storage: 'dry',
    barcode: ' ',
    measurement_unit: 'PAC',
    measurement_unit_desc: 'Pack',
    sales_unit: 'CAR',
    sales_unit_desc: 'Carton',
    dimension: '37,500 X 30,000 X 18,000',
    dimension_unit: 'CM',
    gross_weight: 0.107,
    net_weight: 0.09,
    weight_unit: 'KG',
    gross_weight_desc: '0.107 KG',
    net_weight_desc: '0.09 KG',
    volume: 22275,
    volume_unit: 'CCM',
    minimum_order_quantity: 1000,
    order_quantity_multiple: 1000,
    stock: 0,
    stock_status: 'OUT_OF_STOCK',
    category_name: 'CONFECTIONERY',
    wishlist_id: null,
    product_images: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/20000559_1.jpg',
    ],
    product_image_thumbnails: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/thumbnails/20000559_1_thumbnail_150.webp',
    ],
    product_images_medium: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/medium/20000559_1_medium_400.webp',
    ],
    product_images_large: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/large/20000559_1_large_700.webp',
    ],
    prices: [
      {
        price: 0,
        min_order_quantity: 1,
      },
    ],
    stock_magnifier: 1000,
    sub_category_name: 'CANDY',
    sub_third_category_name: 'SOFT CANDY',
  },
  {
    id: 'ff534b80-18f6-4c3b-8f31-682f4194956c',
    title: 'BAG BLACKCURRANT MANGO 90 GR',
    desc: 'BAG BLACKCURRANT MANGO 90 GR',
    type: 'ZTRD',
    pack_unit: '30X90 GR',
    information:
      'Permen lunak dengan tekstur lembut. Perpaduan rasa buah-buahan dan yoghurt yang segar, membuat hari-hari menjadi lebih berwarna',
    composition:
      'Gula, sirup glukosa, minyak nabati, pengental (gelatin sapi), pengatur keasaman asam sitrat, perisa artifisial (yoghurt, blackcurrant, mangga), ekstrak buah blackcurrant dan mangga (0.04%), gom arab, pewarna artifisial kuning FCF CI 15985, tartrazine CI 19140, azorubin 14720, indigo carmin CI 73105)',
    superiority:
      '- sudah ada di Indonesia lebih dari 40 tahun\r\n  - bahan berkualitas tinggi\r\n  - perpaduan rasa buah dan yogurt yang segar',
    item_code: 20000560,
    brand_name: 'SUGUS',
    brand_desc: 'SUGUS',
    division: 'trading',
    product_storage: 'dry',
    barcode: ' ',
    measurement_unit: 'PAC',
    measurement_unit_desc: 'Pack',
    sales_unit: 'CAR',
    sales_unit_desc: 'Carton',
    dimension: '37,500 X 30,000 X 18,000',
    dimension_unit: 'CM',
    gross_weight: 0.107,
    net_weight: 0.09,
    weight_unit: 'KG',
    gross_weight_desc: '0.107 KG',
    net_weight_desc: '0.09 KG',
    volume: 22275,
    volume_unit: 'CCM',
    minimum_order_quantity: 1000,
    order_quantity_multiple: 1000,
    stock: 0,
    stock_status: 'OUT_OF_STOCK',
    category_name: 'CONFECTIONERY',
    wishlist_id: null,
    product_images: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/20000560_1.jpg',
    ],
    product_image_thumbnails: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/thumbnails/20000560_1_thumbnail_150.webp',
    ],
    product_images_medium: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/medium/20000560_1_medium_400.webp',
    ],
    product_images_large: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/large/20000560_1_large_700.webp',
    ],
    prices: [
      {
        price: 0,
        min_order_quantity: 1,
      },
    ],
    stock_magnifier: 1000,
    sub_category_name: 'CANDY',
    sub_third_category_name: 'SOFT CANDY',
  },
  {
    id: 'd038dabe-f7d0-4f90-b891-c8215e781d12',
    title: 'ARTISAN SUPERGRAIN COOKIE 400 GR',
    desc: 'ARTISAN SUPERGRAIN COOKIE 400 GR',
    type: 'ZTRD',
    pack_unit: '400 GR',
    information: 'DELETED SKUs (discontinue)',
    composition: 'DELETED SKUs (discontinue)',
    superiority: 'DELETED SKUs (discontinue)',
    item_code: 20000700,
    brand_name: 'YYC',
    brand_desc: 'YES YOU CAN',
    division: 'fnb',
    product_storage: 'dry_ac',
    barcode: ' ',
    measurement_unit: 'PAC',
    measurement_unit_desc: 'Pack',
    sales_unit: 'PAC',
    sales_unit_desc: 'Pack',
    dimension: '13,000 X 5,000 X 20,000',
    dimension_unit: 'CM',
    gross_weight: 0.4,
    net_weight: 0.4,
    weight_unit: 'KG',
    gross_weight_desc: '0.4 KG',
    net_weight_desc: '0.4 KG',
    volume: 1300,
    volume_unit: 'CCM',
    minimum_order_quantity: 1000,
    order_quantity_multiple: 1000,
    stock: 0,
    stock_status: 'OUT_OF_STOCK',
    category_name: 'BAKING NEEDS',
    wishlist_id: '4f00ef90-7052-47ce-8019-2c249cc452f3',
    product_images: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/20000700_1.jpg',
    ],
    product_image_thumbnails: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/thumbnails/20000700_1_thumbnail_150.webp',
    ],
    product_images_medium: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/medium/20000700_1_medium_400.webp',
    ],
    product_images_large: [
      'https://diamond-file-uploads-development.s3.ap-southeast-1.amazonaws.com/product-images/large/20000700_1_large_700.webp',
    ],
    prices: [
      {
        price: 0,
        min_order_quantity: 1,
      },
    ],
    stock_magnifier: 1000,
    sub_category_name: 'FLOUR AND PREMIX',
    sub_third_category_name: 'FLOUR AND PREMIX',
  },
];
